import { StateObservable } from 'redux-observable';
import { createSetTranslations, State, SetTranslations } from '../';
import { map } from 'rxjs/operators';

import { EpicDependencies } from '../dependencies.interface';
import { Observable } from 'rxjs';

export const setTranslations = (
  actions$: Observable<SetTranslations>,
  state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<SetTranslations> => dependencies.translations$.pipe(map(createSetTranslations));
